"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrbanDecomposers = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var Resources_1 = require("../../Resources");
var ResourceType_1 = require("../../ResourceType");
var AddResourcesToCard_1 = require("../../deferredActions/AddResourcesToCard");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var UrbanDecomposers = (function (_super) {
    __extends(UrbanDecomposers, _super);
    function UrbanDecomposers() {
        return _super.call(this, {
            cost: 6,
            tags: [Tags_1.Tags.MICROBE],
            name: CardName_1.CardName.URBAN_DECOMPOSERS,
            cardType: CardType_1.CardType.AUTOMATED,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.colonies().cities(); }),
            metadata: {
                cardNumber: 'C48',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.plants(1); }).microbes(2).asterix();
                }),
                description: 'Requires that you have 1 city tile and 1 colony in play. Increase your plant production 1 step, and add 2 microbes to ANOTHER card.',
            },
        }) || this;
    }
    UrbanDecomposers.prototype.canPlay = function (player) {
        var coloniesCount = 0;
        player.game.colonies.forEach(function (colony) {
            coloniesCount += colony.colonies.filter(function (owner) { return owner === player.id; }).length;
        });
        return coloniesCount > 0 && player.getCitiesCount() > 0;
    };
    UrbanDecomposers.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.PLANTS, 1);
        var microbeCards = player.getResourceCards(ResourceType_1.ResourceType.MICROBE);
        if (microbeCards.length) {
            player.game.defer(new AddResourcesToCard_1.AddResourcesToCard(player, ResourceType_1.ResourceType.MICROBE, { count: 2 }));
        }
        return undefined;
    };
    return UrbanDecomposers;
}(Card_1.Card));
exports.UrbanDecomposers = UrbanDecomposers;
//# sourceMappingURL=UrbanDecomposers.js.map